export const fetchThreads = async (selectedTrack) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/thread/get/${selectedTrack.id}`
    );
   
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || "Failed to fetch threads");
    }

    const data = await response.json();
   
    return data;
  } catch (error) {
    console.error("Error fetching threads:", error);
    throw error;
  }
};
